import React, { Component } from "react";

import SGButton from './component_SGButton';

export default class SGButtonsBar extends Component {
  constructor(props) {
    super(props);
  }
  
  render() {
    var props = this.props;
    var buttonList = props.list;
    return (
        <div style={{margin: "15px"}}>
            
        {buttonList && buttonList.map(
            (btn, index) => {
                return ( 
                    <SGButton
                        key             = { index               }
                        tooltip         = { btn.tooltip         }
                        tooltipPosition = { btn.tooltipPosition }
                        disabled        = { btn.disabled        }
                        onClick         = { btn.onClick         }
                        icon            = { btn.icon            }/>
                );
                
            }
        )}
        </div>
      
    );
  }
}


// WEBPACK FOOTER //
// ./src/Components/component_SGButtonsBar.js